import React, { useEffect, useState } from "react";
import { useMyTeam } from "./store";
import CardDiv from "modules/common/card-div/CardDiv";
import { getFormattedDate } from "modules/utilities/utility";
import { Link } from "react-router-dom";
import BreakDayModal from "modules/medrep_engagement/BreakDayModal";
import { Placeholder } from "react-bootstrap";
import NoData from "assets/svgs/no_data/NoData";

function MyTeam() {
  const { myTeam, teamData, isLoading } = useMyTeam();
  const [team, setTeam] = useState([]);
  useEffect(() => {
    myTeam();
  }, []);

  useEffect(() => {
    teamData.length && setTeam(teamData[0].userGroup);
  }, [teamData]);

  return (
    <CardDiv
      component={
        <div
          style={{ maxHeight: "75vh", overflowY: "scroll" }}
          className="scrollable-container shadow rounded-bottom"
        >
          <div
            style={{ background: "#F9FAFD" }}
            className="d-flex rounded-top p-2 py-3 text-black  fw-bold"
          >
            <div style={{ flex: 1.5 }}>Name</div>
            <div style={{ flex: 1.5 }}>Email</div>
            <div className="flex-1">Created at</div>
            <div style={{ flex: 0.5 }}>Action</div>
          </div>
          <div>
            {isLoading ? (
              <div className="px-3">
                <Placeholder as="p" animation="wave">
                  <div className="d-flex justify-content-between gap-3 py-3">
                    <Placeholder xs={2} bg="primary" />
                    <Placeholder xs={3} bg="secondary" />
                    <Placeholder xs={3} bg="secondary" />
                    <Placeholder xs={3} bg="secondary" />
                  </div>
                  <Placeholder xs={4} bg="secondary" />
                </Placeholder>
              </div>
            ) : team.length ? (
              team.map((member, index) => {
                return (
                  <div
                    className={`d-flex border border-top-0 px-2 py-3  ${
                      index === team.length - 1 && `rounded-bottom`
                    }`}
                  >
                    <div style={{ flex: 1.5 }} className="d-flex flex-column">
                      <Link
                        to={`/today-engagement/${member.user_id}`}
                        className="fs-1 text-primary fw-bold"
                      >
                        {member.user.first_name}
                      </Link>
                      <span className="text-black mt-2">
                        {member.user.phone_number}
                      </span>
                    </div>
                    <div style={{ flex: 1.5 }} className=" text-black">
                      {member.user.email}
                    </div>
                    <div className="flex-1 text-black">
                      {getFormattedDate(member.created_at)}
                    </div>
                    <div style={{ flex: 0.5 }}>
                      <BreakDayModal
                        breakDays={member.user.meta.breakWeekDays}
                        id={member.user_id}
                      />
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="p-3 fw-bold d-flex justify-content-center align-items-center">
                <h3 className="mx-3">No Data Available</h3>
                <span>
                  <NoData />
                </span>
              </div>
            )}
          </div>
        </div>
      }
      title={"My Team"}
    />
  );
}

export default MyTeam;
